import React, { useState } from 'react';
import { EditIcon, UsersIcon, SendIcon, ArrowLeftIcon } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { RightPanel } from '../components/RightPanel';
import { ReportForm } from '../components/ReportForm';
import { mockData } from '../utils/mockData';
interface TranscriptEditorProps {
  onOpenAffidavit: () => void;
}
export const TranscriptEditor = ({
  onOpenAffidavit
}: TranscriptEditorProps) => {
  const [isReportPanelOpen, setIsReportPanelOpen] = useState(false);
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const transcript = mockData.transcripts[id as keyof typeof mockData.transcripts] || [];
  const bodycamFootage = mockData.sidebar.bodycamFootage.find(item => item.id === id);
  const handleSubmitReport = () => {
    setIsReportPanelOpen(false);
    onOpenAffidavit();
  };
  return <>
      <main className="flex-grow p-6 overflow-auto" style={{
      backgroundImage: 'radial-gradient(circle at center, #2d4c6b 0%, #1f1f1f 100%)'
    }} data-id="element-534">
        <div className="max-w-[800px] mx-auto" data-id="element-535">
          <div className="mb-6 flex gap-3" data-id="element-536">
            <button className="px-4 py-2 bg-[#1a1a1a] border border-[#444444] rounded-lg text-sm font-medium flex items-center gap-2 hover:bg-[#2a2a2a]" data-id="element-537">
              <EditIcon size={16} data-id="element-538" />
              Edit Transcript
            </button>
            <button className="px-4 py-2 bg-[#1a1a1a] border border-[#444444] rounded-lg text-sm font-medium flex items-center gap-2 hover:bg-[#2a2a2a]" data-id="element-539">
              <UsersIcon size={16} data-id="element-540" />
              Speakers
            </button>
            <div className="flex-grow" data-id="element-541" />
            <button onClick={() => navigate(`/report/${id}`)} className="px-4 py-2 bg-[#4a90e2] text-white rounded-lg text-sm font-medium flex items-center gap-2 hover:bg-[#3a7bc2]" data-id="element-542">
              <SendIcon size={16} data-id="element-543" />
              Transmit Report
            </button>
          </div>
          {bodycamFootage && <h1 className="text-xl font-semibold mb-6" data-id="element-544">
              {bodycamFootage.title}
            </h1>}
          <div className="bg-[#1a1a1a] border border-[#444444] rounded-lg p-6 space-y-4" data-id="element-545">
            {transcript.map(message => <p key={message.id} className="text-sm leading-relaxed" data-id="element-546">
                <strong data-id="element-547">
                  {message.speaker}
                  {message.badge && ` (${message.badge})`}:
                </strong>{' '}
                {message.content}
                <span className="block text-xs text-[#888888] mt-1" data-id="element-548">
                  {message.timestamp}
                </span>
              </p>)}
          </div>
        </div>
      </main>
      <RightPanel isOpen={isReportPanelOpen} onClose={() => setIsReportPanelOpen(false)} data-id="element-549">
        <ReportForm onClose={() => setIsReportPanelOpen(false)} onSubmit={handleSubmitReport} data-id="element-550" />
      </RightPanel>
    </>;
};